"use client";
import { jsx as m } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { useIcon as p } from "./useIcon.js";
const c = e((o, r) => {
  const { Component: n, getIconProps: t } = p({
    ...o,
    ref: r
  });
  return /* @__PURE__ */ m(n, { ...t() });
});
c.displayName = "Icon";
export {
  c as Icon
};
